import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on('click', '.dropdown-menu__link--delete-client', (e) => {
    const { deleteUrl } = $(e.target).data();
    $('#modal--delete-client-confirmation').modal();
    $('#modal--delete-client-confirmation .d-button--confirm-delete').attr('href', deleteUrl);

    return false;
  });

  $(document).on('click', '.dropdown-menu__link--delete-vendor', (e) => {
    const { deleteUrl } = $(e.target).data();
    $('#modal--delete-vendor-confirmation').modal();
    $('#modal--delete-vendor-confirmation .d-button--confirm-delete').attr('href', deleteUrl);

    return false;
  });

  $(document).on('submit', '.vendors-form:not(.vendors-form--billable)', (e) => {
    e.preventDefault();
    const $form = $(e.target);
    const $submitButton = $form.find('.p-button--vendors-form');

    $submitButton.addClass('button-loading').prop('disabled', true);

    const $validationUrl = $submitButton.data().validationUrl;
    $.post($validationUrl, $form.serialize().replace('_method=patch', '_method=post')).done(
      (res) => {
        if (res.valid) {
          if ($('body').is('#purchase-orders-edit')) {
            $.post(
              $form.attr('action'),
              $form.serialize(),
              (data) => {
                document.dispatchEvent(new CustomEvent('vendor:created', { detail: data }));
                $('.close-modal').click();
              },
              'json'
            );
          } else {
            // continue submitting form
            e.currentTarget.submit();
          }
        } else {
          for (const key of Object.keys(res.errors)) {
            $form
              .find('.vendors-form__personal-details--new-vendor')
              .addClass('vendors-form__personal-details--with-errors');

            $form
              .find(`.error-message--vendor-form-${key.replace('_', '-')}`)
              .text([key.replace('_', ' '), res.errors[key].join(' and ')].join(' '))
              .show();
          }
          $submitButton.removeClass('button-loading').prop('disabled', false);
        }
      }
    );
  });
});
